module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "result-content-block"
  }, [(!_vm.detailed) ? _c('h2', [_vm._v(_vm._s(_vm.item.name))]) : _vm._e(), _vm._v(" "), (_vm.item.description) ? _c('p', {
    directives: [{
      name: "nl2br",
      rawName: "v-nl2br",
      value: (_vm.item.description),
      expression: "item.description"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.item.externalUrl) ? _c('a', {
    staticClass: "link-v2",
    attrs: {
      "href": _vm.item.externalUrl
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.externalUrl)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-wrap-block"
  }, [(!_vm.detailed) ? _c('a', {
    staticClass: "button info-btn",
    attrs: {
      "href": _vm.item.url
    }
  }, [_vm._v("Mere info")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "meta result-meta-block",
    class: _vm.detailed ? 'meta-full' : ''
  }, [(_vm.item.type) ? _c('div', {
    staticClass: "column rmb-type"
  }, [(_vm.item.type && _vm.item.type.name) ? _c('div', {
    staticClass: "meta-title-row"
  }, [_c('sky-svg', {
    attrs: {
      "name": "offer-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\tTYPE\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._l((_vm.item.types), function(type, index) {
    return [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(type.name)), (index + 1 < _vm.item.types.length) ? [_vm._v(", ")] : _vm._e()]
  })], 2)])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.audiences) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.type && _vm.item.type.name) ? _c('div', {
    staticClass: "meta-title-row"
  }, [_c('sky-svg', {
    attrs: {
      "name": "offer-audiences"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\tMålgruppe\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block meta-content-block--target"
  }, _vm._l((_vm.item.audiences), function(audience) {
    return (_vm.item.audiences.length) ? _c('span', [_vm._v(_vm._s(audience.name)), _c('em', [_vm._v(",")])]) : _vm._e()
  }), 0)])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.item.organization) && _vm.item.organization.phone) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.organization.phone) ? _c('div', {
    staticClass: "meta-title-row"
  }, [_c('sky-svg', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\tTELEFON\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm.item.organization.phone) + "\r\n\t\t\t\t\t")])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.item.organization) && _vm.item.organization.email) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.organization.email) ? _c('div', {
    staticClass: "meta-title-row"
  }, [_c('sky-svg', {
    attrs: {
      "name": "mail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\tMAIL\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.item.organization.email
    }
  }, [_vm._v(_vm._s(_vm.item.organization.email))])])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.location.parent) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.location.parent) ? _c('div', {
    staticClass: "meta-title-row"
  }, [_c('sky-svg', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\tOmråde\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm.item.location.parent) + "\r\n\t\t\t\t\t")])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.organization.name || _vm.item.organization.address || _vm.item.organization.zipcode || _vm.item.organization.city) ? _c('div', {
    staticClass: "column"
  }, [(_vm.item.organization.name || _vm.item.organization.address || _vm.item.organization.zipcode || _vm.item.organization.city) ? _c('div', {
    staticClass: "meta-title-row"
  }, [_c('sky-svg', {
    attrs: {
      "name": "offer-address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\tADRESSE\r\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm.item.organization.name)), _c('br'), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm.item.organization.address)), (_vm.item.organization.address) ? [_vm._v(",")] : _vm._e(), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm.item.organization.zipcode) + " " + _vm._s(_vm.item.organization.city) + "\r\n\t\t\t\t\t")], 2)])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.detailed) ? [(_vm.item.contactPersons && _vm.item.contactPersons.length) ? _c('div', {
    staticClass: "meta-Kontaktpersoner"
  }, [_c('p', {
    staticClass: "small-block-head-xs"
  }, [_vm._v("Kontaktpersoner")]), _vm._v(" "), _vm._l((_vm.item.contactPersons), function(person) {
    return _c('div', {
      staticClass: "meta-kontact-dv"
    }, [_c('p', {
      staticClass: "small-block-head"
    }, [_vm._v(_vm._s(person.name))]), _vm._v(" "), _c('div', {
      staticClass: "meta result-meta-block meta-full"
    }, [(person.phone) ? _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "meta-title-row"
    }, [_c('sky-svg', {
      attrs: {
        "name": "phone"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "meta-title-label-row"
    }, [_c('div', {
      staticClass: "meta-title-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\tTELEFON\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "meta-content-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t" + _vm._s(person.phone) + "\r\n\t\t\t\t\t\t\t\t")])])], 1)]) : _vm._e(), _vm._v(" "), (person.title) ? _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "meta-title-row"
    }, [_c('div', {
      staticClass: "meta-title-label-row"
    }, [_c('div', {
      staticClass: "meta-title-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\tArbejder som\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "meta-content-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t" + _vm._s(person.title) + "\r\n\t\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (person.email) ? _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "meta-title-row"
    }, [_c('sky-svg', {
      attrs: {
        "name": "mail"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "meta-title-label-row"
    }, [_c('div', {
      staticClass: "meta-title-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\tMAIL\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "meta-content-block"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + person.email
      }
    }, [_vm._v(_vm._s(person.email))])])])], 1)]) : _vm._e(), _vm._v(" "), (person.education) ? _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "meta-title-row"
    }, [_c('div', {
      staticClass: "meta-title-label-row"
    }, [_c('div', {
      staticClass: "meta-title-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\tUddannelse\r\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "meta-content-block"
    }, [_vm._v("\r\n\t\t\t\t\t\t\t\t\t" + _vm._s(person.education) + "\r\n\t\t\t\t\t\t\t\t")])])])]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.item.facts) ? _c('div', {
    staticClass: "meta-fakta"
  }, [_c('p', {
    staticClass: "small-block-head"
  }, [_vm._v("Fakta om dette tilbud")]), _vm._v(" "), _c('div', {
    staticClass: "meta result-meta-block meta-full"
  }, [(_vm.item.facts.form) ? _c('div', {
    staticClass: "column rmb-type"
  }, [_c('div', {
    staticClass: "meta-title-row"
  }, [_c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\tForm på tilbud:\r\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.facts.form) + "\r\n\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.facts.duration) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "meta-title-row"
  }, [_c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\tLængde på forløb:\r\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.facts.duration) + "\r\n\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.facts.participants) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "meta-title-row"
  }, [_c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\tAntal deltagere:\r\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.facts.participants) + "\r\n\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.facts.interval) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "meta-title-row"
  }, [_c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\tHvor ofte er der møde:\r\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.facts.interval) + "\r\n\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.organization.name) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "meta-title-row"
  }, [_c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\tOrganisation bag tilbuddet:\r\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.organization.name) + "\r\n\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.item.facts.cooperation) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "meta-title-row"
  }, [_c('div', {
    staticClass: "meta-title-label-row"
  }, [_c('div', {
    staticClass: "meta-title-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\tLængde på forløb:\r\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "meta-content-block"
  }, [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.item.facts.cooperation) + "\r\n\t\t\t\t\t\t\t")])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.item.location.center) ? _c('div', {
    staticClass: "meta-map-wrapper"
  }, [_c('h2', [_vm._v("Kort")]), _vm._v(" "), _c('gmap-map', {
    staticClass: "single",
    attrs: {
      "center": {
        lat: _vm.item.location.center.lat,
        lng: _vm.item.location.center.lng
      },
      "zoom": 16,
      "options": _vm.mapOptions.settings,
      "map-type-id": "roadmap"
    }
  }, [(_vm.item.location.center) ? _c('gmap-marker', {
    attrs: {
      "icon": "../../6682bo/static/maps-marker.png",
      "position": _vm.item.location.center
    }
  }) : _vm._e()], 1)], 1) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/7572bo/master/~/vue-loader/lib/template-compiler?{"id":"data-v-7cd8a2c4"}!./scripts/bo-list/bo-list-item.html
// module id = 271
// module chunks = 1